/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EodMelcoEodModelsEodSetting,
    EodMelcoEodModelsEodSettingFromJSON,
    EodMelcoEodModelsEodSettingFromJSONTyped,
    EodMelcoEodModelsEodSettingToJSON,
    EodMelcoModelsCustomWarning,
    EodMelcoModelsCustomWarningFromJSON,
    EodMelcoModelsCustomWarningFromJSONTyped,
    EodMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EodMelcoModelsGenericList1MelcoEodModelsEodSetting
 */
export interface EodMelcoModelsGenericList1MelcoEodModelsEodSetting {
    /**
     * 
     * @type {Array<EodMelcoEodModelsEodSetting>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodSetting
     */
    list: Array<EodMelcoEodModelsEodSetting>;
    /**
     * 
     * @type {Array<EodMelcoModelsCustomWarning>}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodSetting
     */
    warning_list?: Array<EodMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EodMelcoModelsGenericList1MelcoEodModelsEodSetting
     */
    total: number;
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodSettingFromJSON(json: any): EodMelcoModelsGenericList1MelcoEodModelsEodSetting {
    return EodMelcoModelsGenericList1MelcoEodModelsEodSettingFromJSONTyped(json, false);
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoModelsGenericList1MelcoEodModelsEodSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EodMelcoEodModelsEodSettingFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EodMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EodMelcoModelsGenericList1MelcoEodModelsEodSettingToJSON(value?: EodMelcoModelsGenericList1MelcoEodModelsEodSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EodMelcoEodModelsEodSettingToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EodMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


